import Image from 'react-bootstrap/Image';

const Header = ({ header }) => {
 return <Image src={header} alt='Header Image' fluid />;
};

export default Header;
